(function ($) {
  const lightbox = new PhotoSwipeLightbox({
    gallery: '#productGallery',
    children: 'a',
    bgOpacity: 1,
    pswpModule: PhotoSwipe,
    closeTitle: 'Zavřít',
    zoomTitle: 'Zvětšit',
    arrowPrevTitle: 'Předchozí',
    arrowNextTitle: 'Další',
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
  });
  lightbox.init();

  // Helper function to initialize sliders with common configuration
  function initializeSlider(selector, options = {}) {
    const defaults = {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      bgColor: 'bg-amber-100',
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    // Merge defaults with provided options
    const config = { ...defaults, ...options };

    $(selector).each(function () {
      const $slider = $(this);
      const $arrowsContainer = $slider.closest('section').find('.slick-arrows-wrapper');

      // Create the final slick configuration
      const slickConfig = {
        ...config,
        prevArrow: `<button type="button" class="slick-prev rotate-180 h-11 w-11 ${config.bgColor} rounded-full cursor-pointer text-center hover:bg-amber-200 active:bg-amber-300"></button>`,
        nextArrow: `<button type="button" class="slick-next h-11 w-11 ${config.bgColor} rounded-full cursor-pointer text-center hover:bg-amber-200 active:bg-amber-300"></button>`,
        appendArrows: $arrowsContainer.length ? $arrowsContainer : $slider,
      };

      // Remove any non-slick properties from the config
      delete slickConfig.bgColor;

      // Initialize slick
      $slider.slick(slickConfig);
    });
  }

  // Initialize all sliders with their specific configurations
  initializeSlider('.gen-references', { bgColor: 'bg-white' });
  initializeSlider('.featured-collection', { slidesToShow: 5 });
  initializeSlider('.featured-blog-posts', { slidesToShow: 5 });

  // mobile menu burger
  $('.header__burger').click(function () {
    $('#navigation_menu').addClass('open_list');
    $('.bg-overlay').toggleClass('filter-overlay');
  });

  $('.header__burger_close').click(function () {
    $('#navigation_menu').removeClass('open_list');
    $('.bg-overlay').toggleClass('filter-overlay');
  });

  $('#navigation_menu li').click(function () {
    $('#navigation_menu').removeClass('open_list');
    $('body').removeClass('overflow-hidden');
  });

  $('.header__menu li').click(function () {
    $('.header__burger').removeClass('open');
    $('body').removeClass('overflow-hidden');
    $('.header__menu').removeClass('open');
  });

  // header search
  $('.header__search--mobile').click(function () {
    $('.header__search').addClass('open');
  });
  $('.header__search__close').click(function () {
    $('.header__search').removeClass('open');
  });

  // my modal test for an image in the article "Proc Genki"
  $('.jsModalPorductImageShower').click(function () {
    $('.jsModalFullsizeImg').addClass('open');
    $('html').addClass('overflow-hidden');
  });

  // modals
  // Use event delegation for the refund guarantee modal
  $(document).on('click', '#refund-garancy-modal-open', function (e) {
    e.preventDefault();
    $('#refund-garancy-modal').addClass('open');
    $('html').addClass('overflow-hidden');
  });

  // Use event delegation for the shipping modal
  $(document).on('click', '#shipping-modal-open', function (e) {
    e.preventDefault();
    $('#shipping-modal').addClass('open');
    $('html').addClass('overflow-hidden');
  });

  $('.jsModalHider').click(function () {
    $('.jsModal').removeClass('open');
    $('html').removeClass('overflow-hidden');
  });

  $(document).keydown(function (e) {
    if (e.keyCode == 27) {
      $('.jsModal').removeClass('open');
      $('html').removeClass('overflow-hidden');
    }
  });

  $('.modal-wrap').click(function (e) {
    // Only close if clicking on the backdrop (modal-wrap or modal), not on modal content
    if ($(e.target).hasClass('modal-wrap') || $(e.target).hasClass('modal')) {
      $('.jsModal').removeClass('open');
      $('html').removeClass('overflow-hidden');
    }
  });
})(jQuery);
